import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'HomeView',
    redirect: '/index',
    component: () => import('@/views/HomeView.vue'),
    meta: {
      requireAuth: true
    },
    children: [
      {
        path: '/index',
        name: 'IndexView',
        component: () => import('@/views/IndexView.vue')
      },
      {
        path: '/channel',
        name: 'ChannelView',
        component: () => import('@/views/ChannelView.vue')
      },
      {
        path: '/newsMore',
        name: 'NewsMore',
        component: () => import('@/components/index/new-more-box.vue')
      },
      { // 普通专题
        path: '/special',
        name: 'SpecialView',
        component: () => import('@/views/SpecialView.vue')
      },
      { // 精品课程
        path: '/classical',
        name: 'Classical',
        component: () => import('@/views/special/classical.vue')
      },
      {
        path: '/news',
        name: 'NewsVIew',
        component: () => import('@/views/NewsVIew.vue')
      },
      {
        path: '/search',
        name: 'SearchView',
        component: () => import('@/views/SearchView.vue')
      },
      {
        path: '/userInfo',
        name: 'UserInfo',
        component: () => import('@/views/UserInfo.vue')
      },
      {
        path: '/setInfo',
        name: 'SetInfo',
        component: () => import('@/views/SetInfo.vue')
      }
    ]
  },{
    path: '/login',
    meta: {
      requireAuth: false
    },
    component: () => import('@/views/LoginView')
  }
  ,{
    path: '/test1',
    meta: {
      requireAuth: false
    },
    component: () => import('@/views/TestView')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
